import React, { useState } from "react";
import axios from "axios";
import cx from "classnames";
import Dialog from "rc-dialog";
import { CourseUserActionTooltip } from "./components/tooltips";

const NotifyUserDialog = ({ course, open, onSuccess, onError, onClose, removeStudentFromCourse, cancelStudentFromCourse, uncancelStudentFromCourse }) => {
    const [loading, setLoading] = useState(false);
    const [notifyUser, setNotifyUser] = useState(false);

    const onSubmit = async () => {
        try {
            setLoading(true);

            if (open?.action === "cancel") await cancelStudentFromCourse(open?.user.uuid, open?.user.full_name);
            else if (open?.action === "delete") await removeStudentFromCourse(open?.user.uuid, open?.user.full_name);
            else if (open?.action === "uncancel") await uncancelStudentFromCourse(open?.user.uuid, open?.user.full_name);

            if (notifyUser) {
                let notification_type;
                if (open?.action === "cancel") notification_type = "student-cancelled";
                else if (open?.action === "delete") notification_type = "student-deleted";
                else if (open?.action === "uncancel") notification_type = "student-reactivated";

                const postData = {
                    users: [open?.user.uuid],
                    notification_type
                };

                await axios.post(`/v1/courses/${course.uuid}/notify/`, postData);
            }

            setLoading(false);
            onSuccess(open?.action, notifyUser);
        } catch (error) {
            console.log(error);
            setLoading(false);
            onError(error);
        }
    };

    const getDialogTitle = () => {
        switch (open?.action) {
            case "cancel":
                return "Cursist annuleren van de cursus";
            case "delete":
                return "Cursist verwijderen van de cursus";
            case "uncancel":
                return "Cursist heractiveren op de cursus";
        }
    };

    return (
        <Dialog title={getDialogTitle()} onClose={onClose} visible={!!open}>
            <>
                {open?.action === "cancel" && <p>De cursist zal worden geannuleerd van de cursus. De cursist blijft wel zichtbaar in het overzicht. </p>}
                {open?.action === "delete" && <p>De cursist zal worden verwijderd van de cursus. </p>}
                {open?.action === "uncancel" && <p>De cursist zal worden geheractiveerd op de cursus. </p>}

                <div className="rc-dialog-overflow">
                    <table className="table table-hover table-clickable">
                        <thead>
                            <tr>
                                <th>NIBHV nummer</th>
                                <th>Naam</th>
                                <th>E-mailadres</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{open?.user?.nibhv_number}</td>
                                <td>{open?.user?.full_name}</td>
                                <td>{open?.user?.email}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="complete-course-toggle">
                        <span className="notify-user-text">
                            Informeer de cursist via e-mail:
                            <CourseUserActionTooltip mode={open?.action} /> &nbsp;
                        </span>
                        <i
                            className={cx("fa toggle-button", notifyUser ? "fa-toggle-on" : "fa-toggle-off")}
                            title="Notify user"
                            onClick={() => setNotifyUser((prev) => !prev)}
                        />
                    </div>
                </div>
            </>

            <div className="flex flex-justify-end">
                <button className="btn btn-secondary" onClick={onClose}>
                    Annuleren
                </button>
                <button className="btn btn-primary no-sideflap" onClick={onSubmit} disabled={loading}>
                    Ja, ik weet het zeker
                </button>
            </div>
        </Dialog>
    );
};

export default NotifyUserDialog;
